import { useContext } from "react";
import { Segmented } from "antd";
import { FaClipboardList, FaCalendarDay, FaTasks, FaCheckCircle, FaTimesCircle, FaRegClock, FaTruckPickup, FaUserClock } from "react-icons/fa";
import { HomeContext } from './HomeContext';

const SegmentedButton = ({ activeButton: propActive, setActiveButton: propSetActive }: { activeButton?: string; setActiveButton?: (v: string) => void }) => {
    const context = useContext(HomeContext) as { activeButton?: string; setActiveButton?: (v: string) => void };
    const activeButton = propActive ?? context?.activeButton ?? 'all_orders';
    const setActiveButton = propSetActive ?? context?.setActiveButton;

    return (
        <Segmented
            value={activeButton}
            options={[
                {
                    label: (
                        <span>
                            <FaRegClock style={{ marginRight: 5, color: "#faad14" }} />
                            Pending Order
                        </span>
                    ),
                    value: "pending_orders",
                },
                {
                    label: (
                        <span>
                            <FaTruckPickup style={{ marginRight: 5, color: "#13c2c2" }} />
                            Ready for Pickup
                        </span>
                    ),
                    value: "ready_for_pickup",
                },
                {
                    label: (
                        <span>
                            <FaUserClock style={{ marginRight: 5, color: "#722ed1" }} />
                            Waiting Driver Accept
                        </span>
                    ),
                    value: "waiting_driver_accept",
                },
              
                {
                    label: (
                        <span>
                            <FaCalendarDay style={{ marginRight: 5, color: "#faad14" }} />
                            Today Orders
                        </span>
                    ),
                    value: "today_orders",
                },
                {
                    label: (
                        <span>
                            <FaTasks style={{ marginRight: 5, color: "#52c41a" }} />
                            Assign Orders
                        </span>
                    ),
                    value: "assign_orders",
                },
                {
                    label: (
                        <span>
                            <FaCheckCircle style={{ marginRight: 5, color: "#eb2f96" }} />
                            Complete Orders
                        </span>
                    ),
                    value: "complete_orders",
                },
                {
                    label: (
                        <span>
                            <FaTimesCircle style={{ marginRight: 5, color: "#ff4d4f" }} />
                            Cancel Orders
                        </span>
                    ),
                    value: "cancel_orders",
                },
                {
                    label: (
                        <span>
                            <FaClipboardList style={{ marginRight: 5, color: "#1890ff" }} />
                            All Orders
                        </span>
                    ),
                    value: "all_orders",
                },
            ]}
            onChange={(value) => setActiveButton?.(value)}
        />
    );
};

export default SegmentedButton;
